<template>
  <div class="cell-header">
    <span class="cell-header-square" />
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: ['title'],
};
</script>

<style lang="less">
.cell-header {
  &-square {
    position: relative;
    top: 2px;
    display: inline-block;
    margin-right: 10px;
    width: 4px;
    height: 16px;
    background-color: #108ee9;
  }
}
</style>
